import { UrlTree } from '@angular/router';
import { Page } from '@spartacus/core';

import { pageTypes, PdpTypeEnum } from '../enums';
import { getPdpType } from './pdp.utils';

const TEMPLATE_TO_PAGE_TYPE_MAP = {
  'HomePageTemplate': pageTypes.HOMEPAGE,
  'CartPageTemplate': pageTypes.CART,
  'AccessoriesHomePageTemplate': pageTypes.ACCESSORY_HOME,
  'SearchResultPageTemplate': pageTypes.SEARCH,
  'AccountPageTemplate': pageTypes.MY_ACCOUNT,
  'NewGenerationTemplate': pageTypes.NGT,
  'RecipeHomePageTemplate': pageTypes.RECIPE,
  'RecipeDetailsPageTemplate': pageTypes.RECIPE,
  'SalesConditionsPageTemplate': pageTypes.SALES_CONDITIONS,
  'BundleDetailsPageTemplate': pageTypes.PDP_BUNDLE
};

const TEMPLATES_WITH_SPECIAL_HANDLING = [
  'CategoryPageTemplate',
  'SubCategoryPageTemplate',
  'ServicePageTemplate',
  'ProductDetailsPageTemplate'
];

const ALL_KNOWN_TEMPLATES = [
  ...Object.keys(TEMPLATE_TO_PAGE_TYPE_MAP),
  ...TEMPLATES_WITH_SPECIAL_HANDLING
];

/**
 * Maps a page template to a page type, handling branded template names
 */
export function mapPageTemplateToPageType(page: Page, urlTree: UrlTree): pageTypes {
  const baseTemplateLabel = extractBaseTemplateLabel(page.template);
  return mapPageTemplateLabelToPageType(baseTemplateLabel, urlTree);
}

/**
 * Extracts the base template label by removing any brand prefixes
 * For example: "Brand-HomePageTemplate" -> "HomePageTemplate"
 */
function extractBaseTemplateLabel(fullTemplateLabel: string): string {
  for (const template of ALL_KNOWN_TEMPLATES) {
    if (fullTemplateLabel?.endsWith(`-${template}`)) {
      return template;
    }
  }
  return fullTemplateLabel;
}

function mapPageTemplateLabelToPageType(pageTemplateLabel: string, urlTree: UrlTree): pageTypes {
  if (TEMPLATE_TO_PAGE_TYPE_MAP[pageTemplateLabel]) {
    return TEMPLATE_TO_PAGE_TYPE_MAP[pageTemplateLabel];
  }

  const hasUrlSegment = (urlTree: UrlTree, segmentPath: string): boolean => (
    !!urlTree?.root?.children?.primary?.segments?.find(
      (segment) => segment.path === segmentPath
    )
  );

  switch (pageTemplateLabel) {
    case 'CategoryPageTemplate':
    case 'SubCategoryPageTemplate':
      return hasUrlSegment(urlTree, 'csc') ? pageTypes.CSC_ACCESSORY : pageTypes.CATEGORY_MARKETING;

    case 'ServicePageTemplate':
      return hasUrlSegment(urlTree, 'csc') ? pageTypes.CSC_IFU : pageTypes.SERVICE;

    case 'ProductDetailsPageTemplate':
      switch (getPdpType(urlTree?.root?.children?.primary?.segments?.[0]?.path)) {
        case PdpTypeEnum.PRODUCT:
          return pageTypes.PDP_FINISHED_PRODUCT;
        case PdpTypeEnum.ACCESSORY:
          return hasUrlSegment(urlTree, 'csp') ? pageTypes.CSP_ACCESSORY : pageTypes.PDP_ACCESSORY;
        case PdpTypeEnum.IFU:
          if (hasUrlSegment(urlTree, 'csp')) {
            return pageTypes.CSP_IFU;
          }
          break;
      }
      return pageTypes.PDP_FINISHED_PRODUCT;
  }

  return undefined;
}
